import { render } from "./SystemLogs.vue?vue&type=template&id=3db75ca6&scoped=true"
import script from "./SystemLogs.vue?vue&type=script&lang=js"
export * from "./SystemLogs.vue?vue&type=script&lang=js"

import "./SystemLogs.vue?vue&type=style&index=0&id=3db75ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db75ca6"]])

export default __exports__